import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context';
import { usePermissions } from '@/hooks/usePermissions';
import { ROUTES } from '@/constants';
import { checkRoutePermission } from '@/constants/permissions';
import PermissionDeniedPage from '@/pages/PermissionDenied/PermissionDeniedPage';

function RoleRoute({ roles, permission, anyRead = false }) {
  const { hasRole, isAuthenticated } = useAuth();
  const { permissions } = usePermissions();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (anyRead && !checkRoutePermission(permissions, { anyRead: true })) {
    return <PermissionDeniedPage />;
  }

  if (permission && !checkRoutePermission(permissions, permission)) {
    return <PermissionDeniedPage />;
  }

  if (roles?.length && !hasRole(...roles)) {
    return <PermissionDeniedPage />;
  }

  return <Outlet />;
}

export default RoleRoute;
